import { Breakpoint } from '@mui/system/createTheme/createBreakpoints';
import { useMediaQuery, useTheme } from '@mui/material';
import { breakpoints } from '@/constants/baseThemes';

const useCurrentBreakpoint = (): Breakpoint => {
  const theme = useTheme();

  const isXl = useMediaQuery(theme.breakpoints.up(breakpoints.values.xl));
  const isLg = useMediaQuery(theme.breakpoints.up(breakpoints.values.lg));
  const isMd = useMediaQuery(theme.breakpoints.up(breakpoints.values.md));
  const isSm = useMediaQuery(theme.breakpoints.up(breakpoints.values.sm));

  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isMd) return 'md';
  if (isSm) return 'sm';
  return 'xs';
};

export default useCurrentBreakpoint;
